import {
  FacilityType,
  SchedulesSearchPartner,
} from '@/types/professional/professional.type';

export function getPartnerUrl(partner: SchedulesSearchPartner): string {
  return partner.facility.type === FacilityType.BRANCH
    ? `/laboratorios/${partner.facility.slug}/`
    : `/parceiros/${partner.facility.slug}/`;
}
